<template>
  <main class="main inside-page form-page recover-page">
    <div class="section recover-section">
      <div class="left">
        <div class="left-wrapper">
          <router-link to="/" class="logo">
            <img class="img" src="../images/logo.svg" />
            <div class="title tiny">Elystr</div>
          </router-link>
          <div class="title">
            {{ $t("Restore password") }}
          </div>
          <ValidationObserver
            ref="form"
            v-slot="{ handleSubmit }"
            slim
            class="form"
          >
            <form @submit.prevent="submit" class="form">
              <ValidationProvider
                rules="required:confirmed:password_confirmation"
                v-slot="{ errors }"
                vid="password"
                slim
              >
                <label class="label">
                  <div class="desc">{{ $t("Password") }}:</div>
                  <input
                    v-model="password"
                    name="password"
                    type="password"
                    :placeholder="$t('Enter your password')"
                  />
                  <div v-if="errors.length" class="error">
                    {{ errors[0] }}
                  </div>
                </label>
              </ValidationProvider>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                vid="password_confirmation"
                slim
              >
                <label class="label">
                  <div class="desc">{{ $t("Confirm password") }}:</div>
                  <input
                    v-model="password_confirmation"
                    name="password"
                    type="password"
                    :placeholder="$t('Enter your password')"
                  />
                  <div v-if="errors.length" class="error">
                    {{ errors[0] }}
                  </div>
                </label>
              </ValidationProvider>
              <div class="button-container">
                <button type="submit" class="button colored">
                  {{ $t("Continue") }}
                </button>
              </div>
              <div class="center-link-container">
                <div class="desc">{{ $t("Don't have an account?") }}</div>
                <router-link to="/register" class="desc link">
                  <b>{{ $t("Sign Up") }}</b>
                </router-link>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
      <div class="right"></div>
    </div>
  </main>
</template>

<script>
import axios from "@/axios";
import { mapActions } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "Recover",
  props: [],
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data: function () {
    return {
      password: "",
      password_confirmation: "",
    };
  },
  mounted() {},
  methods: {
    submit() {
      const self = this;

      axios
        .post("user/password-reset", {
          password: this.password_confirmation,
          password_confirmation: this.password_confirmation,
          token: this.$route.query.token,
          email: this.$route.query.email,
        })
        .then(({ data }) => {
          if (data.status === "OK") {
            self.showNotification({
              text: this.$t("Password successfully restored!"),
            });
            self.$router.push("/login");
          } else if (data.status === "ERROR") {
            self.showNotification({ text: data.message });
          }
        })
        .catch(({ response }) => {
          if (response.data.status === "ERROR") {
            self.showNotification({ text: response.data.message });
          }
        });
    },
    ...mapActions("app", ["showNotification"]),
  },
};
</script>
